// The one email format check for the UI (directive, contact entry, search fields).
// ASCII apostrophe is allowed (o'brien@...); a U+2019 copy of this pattern used to reject it.
export const EMAIL_PATTERN = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/;

export const isEmail = (value: string): boolean => !!value && EMAIL_PATTERN.test(value);
